import { render, staticRenderFns } from "./AnnotatorsDetailPane.vue?vue&type=template&id=14598356&scoped=true&"
import script from "./AnnotatorsDetailPane.vue?vue&type=script&lang=js&"
export * from "./AnnotatorsDetailPane.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatorsDetailPane.vue?vue&type=style&index=0&id=14598356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14598356",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VSimpleTable})
